<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded01">
<a id="pagevii">
<p class="dedicationText">I wrote parts of this book while staying at my in-laws house as my father-in-law fought his last few days against cancer. It was there, at his bedside, that I learned the true meaning of character, both from him and in watching the stream of caregivers who stood by his side.</p>
<p class="dedicationText">To Hospice of St. Francis in Titusville, FL. Thank you for taking such beautiful, compassionate care of my incredible father-in-law who was able to die as he had lived—strong, proud, and loved.</p>
</a><p class="dedicationText"><a id="pagevii"><span class="xrefURL"></span></a><a href="http://www.hospiceofstfrancis.com" target="_blank">www.hospiceofstfrancis.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781439164341_ded01.vue?30ecf2d4